module.exports = __webpack_public_path__ + "img/404-error-with-a-cute-animal.fadc6416.svg";